import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImgOverlay, ErrorMessage } from './styles';

const Overlay = ({ item, hasError }) => {
  const { t } = useTranslation();
  return (
    <ImgOverlay hasError={hasError}>
      <ErrorMessage>
        <p>{t(item.error || 'professionalPubli.multimedia.image.errorGeneric')}</p>
      </ErrorMessage>
    </ImgOverlay>
  );
};

export default Overlay;
